var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2C8.58878 2 5 5.57423 5 9.96753C5 15.4198 12.1592 23.4239 12.464 23.762C12.7503 24.0796 13.2502 24.079 13.536 23.762C13.8408 23.4239 21 15.4198 21 9.96753C20.9999 5.57423 17.4112 2 13 2ZM13 13.9762C10.7806 13.9762 8.97504 12.1779 8.97504 9.96753C8.97504 7.75713 10.7806 5.95889 13 5.95889C15.2194 5.95889 17.0249 7.75718 17.0249 9.96758C17.0249 12.178 15.2194 13.9762 13 13.9762Z",
    stroke: "#1D1D1B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLocation;